module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/convant-811fcb59a130db86181076e7e0ce89ab.svg";